import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  useLocale,
  LocalePickerPage as LibraryLocalePickerPage,
} from "@cloudaccelerator-ui/react-library";
import cultureDictionary from "@/../public/config/culture-dictionary.json";

const staticLocales = Object.entries(cultureDictionary).map(([code, info]) => ({
  code,
  name: info.nativeName,
  isEnabled: true,
  isDefault: code === "en-us",
}));

export function LocalePickerPage(): React.ReactElement {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { changeLanguage } = useLocale();

  const handleLocaleSelect = (localeCode: string): void => {
    changeLanguage(localeCode as Parameters<typeof changeLanguage>[0]);
    navigate("/");
  };

  return (
    <LibraryLocalePickerPage
      locales={staticLocales}
      onSelect={handleLocaleSelect}
      title={t("localePicker.title", "Select Your Language")}
      loadingMessage={t("localePicker.loading", "Loading languages...")}
      errorTitle={t("localePicker.errorTitle", "Error")}
      errorMessage={t("localePicker.errorMessage", "Failed to load available languages.")}
      noLocalesTitle={t("localePicker.noLocalesTitle", "No Languages Available")}
      noLocalesMessage={t(
        "localePicker.noLocalesMessage",
        "No languages are currently available. Please try again later.",
      )}
    />
  );
}
